module.exports = __webpack_public_path__ + "img/zenspace.ee955960.png";